import Vue from 'vue';
import Vuex from 'vuex';
import registrations from '../registration/registrationStore';
import authentication from '../authentication/authenticationStore';
import users from '../user/userStore';
import support from '../support/supportStore';
import * as types from './mutation-types';
import i18n from '../i18n/i18n';

Vue.use(Vuex);

const state = {
    language: i18n.locale
};

export default new Vuex.Store({
    modules: {
        registrations: registrations,
        authentication: authentication,
        users: users,
        support: support
    },
    getters: {
        getLanguage(state) {
            return state.language;
        }
    },
    state: state,
    mutations: {
        [types.LANGUAGE_CHANGE](state, language) {
            i18n.locale = language;
            window.localStorage.setItem('userLanguage', language);
            state.language = language;
        }
    }
});
